import React, { useCallback, useContext, useEffect, useState } from "react";

import Header from 'components/Dashboard/Header'

import {
    DashboardPage,
    DashboardBody,
    DashboardBodyContent,
    Content
} from "./styled";
import { ReadObject } from "services/storage";
import { useHistory } from "react-router-dom";
import { ThemedComponent } from "ui/theme";
import { CoreContext } from "context/CoreContext";
import MagAssistant from "components/MagAssistant";
import { HydrateIdentitySessions, ReadIdentitySession } from 'services/identity';
import { isProfileNative, profileAllowsArea, profileNeedsCompletion, profileCompletionPath, passwordChangeRequired, passwordChangePath } from 'services/profile';

export default function ContainerAuthenticated({ children, noheader, headerSecondary, simplified, side, filtred, isActive, setIsActive, keep, share, student, portal, navigationVariant, fullWidth, contentVariant }) {

    const history = useHistory();
    const navigate = useCallback((to) => history.push(`/${to}`), [history]);
    const resolvedPortal = portal || (student ? 'essentials' : null);

    const [isSimplified] = useState(simplified);
    const [checkingProfile, setCheckingProfile] = useState(true);
    const { reloadMe } = useContext(CoreContext)

    const completeNext = useCallback(() => {
        navigate('login')
    }, [navigate]);

    const canAccessMVUEssentials = useCallback((currentUser) => {
        if (!currentUser) return false;
        return profileAllowsArea(currentUser, 'lite');
    }, []);

    const canAccessMVUAccelerator = useCallback((currentUser) => {
        if (!currentUser) return false;
        return profileAllowsArea(currentUser, 'accelerator');
    }, []);

    const init = useCallback(async () => {
        if (keep) { setCheckingProfile(false); return; }

        const authenticationMvuEssentials = ReadObject('mvu_essentials');
        const authenticationMvuAccelerator = ReadObject('mvu_accelerator');
        const authentication = ReadObject('authentication');
        const identity = ReadIdentitySession();
        if (identity?.centralUserId || isProfileNative(authentication?.user) || isProfileNative(authenticationMvuEssentials?.user) || isProfileNative(authenticationMvuAccelerator?.user)) {
            const refreshed = await HydrateIdentitySessions();
            const effectiveIdentity = ReadIdentitySession();
            const area = resolvedPortal === 'essentials' ? 'lite' : resolvedPortal === 'accelerator' ? 'accelerator' : 'universe';
            if ((isProfileNative(identity) && !refreshed) || !effectiveIdentity?.areas?.includes(area)) {
                navigate(area === 'lite' ? 'mvu-lite/login' : area === 'accelerator' ? 'mvu-accelerator/login' : 'login');
                return;
            }
            if (passwordChangeRequired(ReadObject(area === 'lite' ? 'mvu_essentials' : area === 'accelerator' ? 'mvu_accelerator' : 'authentication')?.user)) {
                history.replace(passwordChangePath(area));
                return;
            }
            if (profileNeedsCompletion(ReadObject(area === 'lite' ? 'mvu_essentials' : area === 'accelerator' ? 'mvu_accelerator' : 'authentication')?.user)) {
                history.replace(profileCompletionPath(area));
                return;
            }
            setCheckingProfile(false);
            const me = await reloadMe();
            if (isProfileNative(effectiveIdentity) && (!isProfileNative(me) || !profileAllowsArea(me, area))) {
                navigate(area === 'lite' ? 'mvu-lite/login' : area === 'accelerator' ? 'mvu-accelerator/login' : 'login');
            }
            return;
        }

        setCheckingProfile(false);
        if (resolvedPortal === 'essentials') {
            if (authenticationMvuAccelerator?.jwt) {
                navigate('mvu-accelerator');
                return;
            }

            if (authenticationMvuEssentials?.jwt) {
                return;
            }

            if (!authentication?.jwt) {
                navigate('mvu-lite/login');
                return;
            }

            const me = await reloadMe();
            const currentUser = me?.id ? me : ReadObject('user');
            if (!canAccessMVUEssentials(currentUser)) {
                navigate('mvu-lite/login');
                return;
            }
            return;
        }

        if (resolvedPortal === 'accelerator') {
            if (authenticationMvuEssentials?.jwt) {
                navigate('mvu-lite');
                return;
            }

            if (authenticationMvuAccelerator?.jwt) {
                return;
            }

            if (!authentication?.jwt) {
                navigate('mvu-accelerator/login');
                return;
            }

            const me = await reloadMe();
            const currentUser = me?.id ? me : ReadObject('user');
            if (!canAccessMVUAccelerator(currentUser)) {
                navigate('mvu-accelerator/login');
                return;
            }
            return;
        }

        if (authenticationMvuAccelerator?.jwt) {
            navigate('mvu-accelerator');
            return;
        }

        if (authenticationMvuEssentials?.jwt) {
            navigate('mvu-lite');
            return;
        }

        if (!authentication?.jwt) {
            completeNext();
            return;
        }

        const me = await reloadMe();
        const currentUser = me?.id ? me : ReadObject('user');
        if (canAccessMVUAccelerator(currentUser)) {
            navigate('mvu-accelerator');
            return;
        }
        if (canAccessMVUEssentials(currentUser)) {
            navigate('mvu-lite');
        }
    }, [keep, resolvedPortal, canAccessMVUEssentials, canAccessMVUAccelerator, completeNext, navigate, reloadMe, history]);

    useEffect(() => {
        init()
        window.scrollTo(0, 0)
    }, [init])

    return (
        <>
            <ThemedComponent>
                <Content contentVariant={contentVariant}>
                    <DashboardPage>
                        {noheader ? null : <Header student={student} portal={resolvedPortal} isActive={isActive} setIsActive={setIsActive} filtred={filtred} side={side} headerSecondary={headerSecondary} share={share} navigationVariant={navigationVariant} />}
                        <DashboardBody simplified={isSimplified} side={side} navigationVariant={navigationVariant}>
                            <DashboardBodyContent contentVariant={contentVariant}>
                                {checkingProfile ? null : children}
                            </DashboardBodyContent>
                        </DashboardBody>
                    </DashboardPage>
                    <MagAssistant portal={resolvedPortal || 'universe'} />
                </Content>
            </ThemedComponent>
        </>
    );
}
